import CarExpandSliderContainer from "../../../components/car/detail/CarExpandSlider";

const CarExpandSlider = () => {
  return <CarExpandSliderContainer />;
};

export default CarExpandSlider;
